/* @flow */
import createChainedFunction from 'utils/createChainedFunction';
import EventTrackingMixin from 'components/mixins/EventTrackingMixin';
import Input from 'components/Input.jsx';
import React from 'react';

const TrackedInput = React.createClass({
  mixins: [
    EventTrackingMixin,
  ],

  handleFocus() {
    this.trackClick();
  },

  render() {
    return (
      <Input
        {...this.props}
        onFocus={createChainedFunction(this.props.onFocus, this.handleFocus)}
      />
    );
  },
});

export default TrackedInput;



// WEBPACK FOOTER //
// ./src/components/TrackedInput.jsx